import { useTour } from '@reactour/tour';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { removeEmpty, useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';

import c from '../utils/constants';

export default function useUpdateEventStatus() {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;
  const { isOpen, setIsOpen } = useTour();

  return useMutation({
    mutationFn: async (payload: {
      id: string;
      values: Record<string, any>;
    }) => {
      if (isOpen) return setIsOpen(false);

      const api = new Api(args);

      const data = await api.patch(
        await withAcl({
          account: {
            url: `/api/v1/calendar/events/${payload.id}/status`,
            payload: removeEmpty(payload.values),
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/calendar/events/${payload.id}/status`,
            payload: removeEmpty(payload.values),
          },
        }),
      );

      return data;
    },
    onSuccess: (successData) => {
      const { data } = successData ?? {};
      const { dealId } = data ?? {};

      queryClient.invalidateQueries({ queryKey: [c.EVENTS] });

      if (dealId) {
        queryClient.invalidateQueries({ queryKey: [c.LOGS, dealId] });
      }

      toastSuccess('Successfully updated event status.');
    },
  });
}
